// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Barge\ApiBarge.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';

// BargeData is the class that Barge serializes to/from
export interface BargeData {
    Id : number;
    Url : string | null;
	
    PortCalls : PortCallData[] | null;
	
    AuditKey : /* GUID */ string | null;
    Beam : NullableMeasurementData;
    GrossTonnage : NullableMeasurementData;
    Guid : /* GUID */ string;
    Length : NullableMeasurementData;
    Name : string | null;
}

// BargeOptions is the class which may be passed to the Barge constructor to define optional initial data values
export interface BargeOptions {
    Id : number;
    Url? : string | null;
	
    PortCalls? : PortCallOptions[] | null;
	
    AuditKey? : /* GUID */ string | null;
    Beam? : NullableMeasurementOptions;
    GrossTonnage? : NullableMeasurementOptions;
    Guid? : /* GUID */ string;
    Length? : NullableMeasurementOptions;
    Name? : string | null;
}

export class Barge {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public PortCalls : SDataArray<PortCall>;
	
    public AuditKey : DataSignal<string | null>;
    public Beam : NullableMeasurement;
    public GrossTonnage : NullableMeasurement;
    public Guid : DataSignal<string>;
    public Length : NullableMeasurement;
    public Name : DataSignal<string | null>;

    constructor();
    constructor(data : BargeOptions);
    constructor(data: BargeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.PortCalls = SArray<PortCall>([]);
	    
        this.AuditKey = jsonableObservable(S.value<string | null>(data && data.AuditKey !== undefined ? data.AuditKey : null));
        this.Beam = data && data.Beam !== undefined ? new NullableMeasurement(data.Beam) : new NullableMeasurement();
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new NullableMeasurement(data.GrossTonnage) : new NullableMeasurement();
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Length = data && data.Length !== undefined ? new NullableMeasurement(data.Length) : new NullableMeasurement();
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
    }

    static key(obj : Barge) {
        return obj.Id();
    }
    
    static dataKey(obj : BargeOptions) {
        return obj.Id;
    }

    static update(obj : Barge, data : BargeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.AuditKey !== undefined) obj.AuditKey(data.AuditKey);
            if (data.Beam !== undefined) NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.GrossTonnage !== undefined) NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Length !== undefined) NullableMeasurement.update(obj.Length, data.Length);
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Barge.ts